/**
 *  08/11/2019 v 1.0 - JuanMa
 **/


export const getFileName= (cadenaPath) => {
    let parts= cadenaPath.split("/");
    if (parts.length == 0)
        return "";
    return parts[parts.length-1];
}
